export default __webpack_public_path__ + "static/media/CB_logo.c1294753.svg";